export const OPEN_SIGNIN_EVENT = "open-signin-modal";

// Open the shared Sign In modal mounted in PageWrapper.
export function openSignInModal(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_SIGNIN_EVENT));
}
